import { render } from "./AddEditCustomer.html?vue&type=template&id=ec38342e&scoped=true"
import script from "./AddEditCustomer.js?vue&type=script&lang=js"
export * from "./AddEditCustomer.js?vue&type=script&lang=js"

import "./AddEditCustomer.css?vue&type=style&index=0&id=ec38342e&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec38342e"]])

export default __exports__